'use strict';var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||!1;descriptor.configurable=!0;if('value'in descriptor)descriptor.writable=!0;Object.defineProperty(target,descriptor.key,descriptor)}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor}}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError('Cannot call a class as a function')}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError('this hasn\'t been initialised - super() hasn\'t been called')}return call&&(typeof call=='object'||typeof call=='function')?call:self}function _inherits(subClass,superClass){if(typeof superClass!='function'&&superClass!==null){throw new TypeError('Super expression must either be null or a function, not '+typeof superClass)}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:!1,writable:!0,configurable:!0}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass}

const _=require('pulsar-utils/dist-es6/_');
const BaseControllerBackedDirective=require('../../../../dist-es6/client/angularCommon/baseControllerBackedDirective');
const tryGet=require('pulsar-utils/dist-es6/extensions/tryGet');
const BaseController=require('../../../../dist-es6/client/angularCommon/baseController');
const timespan=require('pulsar-utils/dist-es6/time/timespan');let

EstimatesAsOfStatusDirective=function(_BaseControllerBacked){_inherits(EstimatesAsOfStatusDirective,_BaseControllerBacked);function EstimatesAsOfStatusDirective(){_classCallCheck(this,EstimatesAsOfStatusDirective);return _possibleConstructorReturn(this,_BaseControllerBacked.apply(this,arguments))}_createClass(EstimatesAsOfStatusDirective,[{key:'templateUrl',get:function()
{return'/templates/directives/estimatesAsOfStatusDirective/estimatesAsOfStatusTemplate'}},{key:'controller',get:function()
{return EstimatesAsOfStatusDirectiveController}},{key:'objectBindings',get:function()
{return['time','timezone']}}]);return EstimatesAsOfStatusDirective}(BaseControllerBackedDirective);


const FiveMinutesInMilliseconds=timespan.fromMinutes(5).totalMilliseconds();
const ThirtyMinutesInMilliseconds=timespan.fromMinutes(30).totalMilliseconds();let

EstimatesAsOfStatusDirectiveController=function(_BaseController){_inherits(EstimatesAsOfStatusDirectiveController,_BaseController);
function EstimatesAsOfStatusDirectiveController(uncaughtErrorHandler,$timeout,$scope,$interval,dateService,timeFormattingService){_classCallCheck(this,EstimatesAsOfStatusDirectiveController);var _this2=_possibleConstructorReturn(this,
_BaseController.call(this,uncaughtErrorHandler,$timeout,$scope));

_this2._dateService=dateService;
_this2._timeFormattingService=timeFormattingService;
_this2._$scope=$scope;
_this2._$interval=$interval;
_this2._$timeout=$timeout;

_this2._safeWatch('time',function(){return _this2._updateVisualTime()});
_this2._safeWatch('timezone',function(){return _this2._updateVisualTime()});

const timeUpdateInterval=$interval(function(){
if(_this2._lastUpdate&&_this2._dateService.now()-_this2._lastUpdate.getTime()<FiveMinutesInMilliseconds){
return;
}

_this2._$scope.$evalAsync(function(){return _this2._updateVisualTime()});
},FiveMinutesInMilliseconds,0,!1);

_this2._$scope.$on('$destroy',function(){return $interval.cancel(timeUpdateInterval)});

_this2._updateVisualTime();return _this2;
}EstimatesAsOfStatusDirectiveController.prototype.

_updateVisualTime=function _updateVisualTime(){var _this3=this;
this._formattedTime=tryGet(this.time).then(function(t){return _.exists(_this3.timezone)?
_this3._timeFormattingService.timeAndFullDateInTimezone(t,_this3.timezone):
_this3._timeFormattingService.timeAndFullDateInLocalTime(t)}).
otherwise('');

this._shouldWarn=_.exists(this.time)&&this._dateService.now().getTime()-this.time.getTime()>ThirtyMinutesInMilliseconds;

this._lastUpdate=this._dateService.now();
};_createClass(EstimatesAsOfStatusDirectiveController,[{key:'formattedTime',get:function()

{
return this._formattedTime;
}},{key:'shouldWarn',get:function()


{
return this._shouldWarn;
}}]);return EstimatesAsOfStatusDirectiveController}(BaseController);


module.exports=EstimatesAsOfStatusDirective;
//# sourceMappingURL=estimatesAsOfStatusDirective.js.map
